// extracted by mini-css-extract-plugin
module.exports = {"label_for_context_text":"apiForm_label_for_context_text__2Eavv","link_url":"apiForm_link_url__3xvp6","separate":"apiForm_separate__2eEVr"};